import { createNullCache } from '@algolia/cache-common';
import { AuthMode } from '@algolia/client-common';
import { getAlgoliaEnv } from '@caresend/types';
import algoliasearch from 'algoliasearch';
import { ALGOLIA_APP_ID } from '../firebaseConfig/credentials.js';
import { isProd, isEmulatedDbAuth } from '../firebaseConfig/init.js';

const createClient = (apiKey) => algoliasearch(ALGOLIA_APP_ID, apiKey, {
    responsesCache: createNullCache(),
    requestsCache: createNullCache(),
    authMode: AuthMode.WithinQueryParameters,
});
const algoliaEnv = getAlgoliaEnv(isProd, isEmulatedDbAuth);

export { algoliaEnv, createClient };
